// extracted by mini-css-extract-plugin
export default {"reportsContent":"Reports_reportsContent__WlsRW","reportsTabs":"Reports_reportsTabs__ywEdt"};